@if (!data?.withoutTitle) {
  <div class="dialog-title">
    <h2 mat-dialog-title>
      <ng-content select="[title]"></ng-content>
    </h2>
    @if (!data?.withoutCancelBtn) {
      <button mat-button mat-dialog-close class="close-btn-icon">
        <i class="material-icons">close</i>
      </button>
    }
  </div>
}

@if (!data?.withoutTopHr) {
  <hr/>
}

<mat-dialog-content [ngClass]="data?.dialogContentClass || ''">
  <ng-content select="[content]"></ng-content>
</mat-dialog-content>

@if (!data?.likeAPopup) {
  <hr class="mb-0" />
}

@if (!data?.withoutAction) {
  <mat-dialog-actions align="end">
    @if (data?.closeBtn) {
      <button mat-button mat-dialog-close>
        <ng-content select="[closeBtnTitle]"></ng-content>
      </button>
    }
    <ng-content select="[actionBtns]"></ng-content>
  </mat-dialog-actions>
}
